import { Link } from 'react-router-dom';
import Icon from '../components/Icon';
import CompanyAddress from '../components/CompanyAddress';
import {
  COMPANY_NAME,
  FOOTER_DISCLAIMER,
  SUPPORT_EMAIL,
  SUPPORT_PHONE,
  SUPPORT_PHONE_TEL,
} from '../constants/site';

export default function PolicyLayout({
  title,
  updated,
  intro,
  children,
  showDisclaimer = true,
}) {
  return (
    <>
      <section className="policy-hero">
        <div className="container">
          <p className="policy-crumbs">
            <Link to="/">Home</Link>
            <Icon name="chevron" size={14} style={{ transform: 'rotate(-90deg)' }} />
            <span>{title}</span>
          </p>
          <h1>{title}</h1>
          <p>Last updated: {updated}</p>
        </div>
      </section>

      <section className="policy-body">
        <div className="container container--narrow">
          <div className="policy-card">
            {intro && <p>{intro}</p>}
            {children}

            <h2>Contact &amp; Registered Office</h2>
            <p>
              This website is operated by <strong>{COMPANY_NAME}</strong>. Written notices and
              formal requests relating to this policy should be sent to the registered office
              below.
            </p>
            <div className="policy-address">
              <CompanyAddress />
              <div className="policy-address__links">
                <a href={`tel:${SUPPORT_PHONE_TEL}`}>
                  <Icon name="phone" size={16} />
                  {SUPPORT_PHONE}
                </a>
                <a href={`mailto:${SUPPORT_EMAIL}`}>
                  <Icon name="mail" size={16} />
                  {SUPPORT_EMAIL}
                </a>
              </div>
            </div>

            {showDisclaimer && (
              <>
                <h2>Disclaimer</h2>
                {FOOTER_DISCLAIMER.map((paragraph) => (
                  <p key={paragraph}>{paragraph}</p>
                ))}
              </>
            )}

            <div className="policy-note">
              <p>
                <strong>Questions about this policy?</strong> Reach our team at{' '}
                <a href={`mailto:${SUPPORT_EMAIL}`} style={{ color: 'var(--red)', fontWeight: 600 }}>
                  {SUPPORT_EMAIL}
                </a>{' '}
                or call{' '}
                <a
                  href={`tel:${SUPPORT_PHONE_TEL}`}
                  style={{ color: 'var(--red)', fontWeight: 700 }}
                >
                  {SUPPORT_PHONE}
                </a>
                . We respond to written enquiries within two business days.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
